import { takeLatest, put, select, call } from 'redux-saga/effects';

import toaster from '@giro/shared-store/toaster';
import auth from '@giro/shared-store/auth';

import dialogData from '.';

import postDispatchService from '@giro/shared-services/link/postDispatch.service';
import postApiDebtsExternalIdService from '@giro/shared-services/debts/postApiDebtsExternalId.service';
import clients from '@giro-pdv/modules/pdv/store/clients';
import { useSelector, useDispatch } from 'react-redux';

import { segmentNormalizeInvertConstant } from '@giro-pdv/constants/segmentNormalize.constant';

function* handleServicePost(action) {
  const { payload } = action;
  const { boleto } = payload.data;

  yield put(dialogData.action.fetchStart());
  const selectorClientsPdv = useSelector(clients.selector.selectState);

  const payloadFormatted = {
    destination: payload.destination,
    type: payload.type,
    subtype: payload.subtype,
    data: {
      vencimento: payload.data.vencimento,
      descricao: payload.data.descricao,
      enviado_por: selectorClientsPdv?.payload?.nmFantasia,
    },
    attachment: boleto,
  };

  try {
    const [success, data] = yield call(() =>
      postDispatchService(payloadFormatted)
    );

    if (!success) {
      throw data;
    }

    if (success) {
      yield put(dialogData.action.fetchSuccess(data));
      yield put(
        toaster.action.show({
          message: 'Boleto enviado com sucesso!',
          variant: 'success',
        })
      );
    }
  } catch (error) {
    yield put(dialogData.action.fetchError());
  }
}

function* handleSetOpen(action) {
  const { payload } = action;

  try {
    yield put(dialogData.action.fetchStart());

    yield put(dialogData.action.updateReferenceId(payload.referencia_externa));

    yield put(dialogData.action.fetchSuccess(payload));
  } catch (error) {
    yield put(dialogData.action.fetchError());
  }
}

function* watch() {
  yield takeLatest(
    dialogData.constant.ACTION_TYPES.SERVICE.POST,
    handleServicePost
  );
  yield takeLatest(dialogData.constant.ACTION_TYPES.SET.OPEN, handleSetOpen);
}

export default {
  watch,
};
